import React, { useEffect, useState,forwardRef, useImperativeHandle,useRef } from 'react';
import ApexCharts from 'react-apexcharts';
import html2canvas from 'html2canvas';
import { Document, Packer, Paragraph, ImageRun } from "docx";
import { saveAs } from 'file-saver';

const ISGraph = ({ data }) => {
  const [series, setSeries] = useState([]);
  
  useEffect(() => {
    const datasets = [
      {
        name: 'Action Prior Stage',
        data: [
          {
            x: 0.25,
            y: 0
        }, {
            x: 0.25,
            y: -5
        }, {
            x: 0.25,
            y: -10
        }, {
            x: 0.25,
            y: -15
        }, {
            x: 0.25,
            y: -20
        }, {
            x: 0.25,
            y: -25
        }, {
            x: 0.25,
            y: -30
        }, {
            x: 0.41,
            y: -35
        }, {
            x: 0.58,
            y: -40
        }, {
            x: 0.78,
            y: -45
        }, {
            x: 0.88,
            y: -50
        }, {
            x: 0.88,
            y: -55
        }, {
            x: 0.88,
            y: -60
        }, {
            x: 0.70,
            y: -65
        }, {
            x: 0.50,
            y: -70
        }, {
            x: 0.37,
            y: -75
        }, {
            x: 0.25,
            y: -80
        }, {
            x: 0.25,
            y: -85
        }, {
            x: 0.25,
            y: -90
        }, {
            x: -0.25,
            y: -90
        }, {
            x: -0.25,
            y: -85
        }, {
            x: -0.25,
            y: -80
        }, {
            x: -0.25,
            y: -75
        }, {
            x: -0.25,
            y: -70
        }, {
            x: -0.25,
            y: -65
        }, {
            x: -0.25,
            y: -60
        }, {
            x: -0.25,
            y: -55
        }, {
            x: -0.25,
            y: -50
        }, {
            x: -0.25,
            y: -45
        }, {
            x: -0.25,
            y: -40
        }, {
            x: -0.25,
            y: -35
        }, {
            x: -0.25,
            y: -30
        }, {
            x: -0.25,
            y: -25
        }, {
            x: -0.25,
            y: -20
        }, {
            x: -0.25,
            y: -15
        }, {
            x: -0.25,
            y: -10
        }, {
            x: -0.25,
            y: -5
        }, {
            x: -0.25,
            y: -0
        }
        ],
        color: '#FCD12A'
      },
      {
        name: 'Max Prior Stage',
        data: [
          {
            x: 0.50,
            y: 0
        }, {
            x: 0.50,
            y: -5
        }, {
            x: 0.50,
            y: -10
        }, {
            x: 0.50,
            y: -15
        }, {
            x: 0.50,
            y: -20
        }, {
            x: 0.50,
            y: -25
        }, {
            x: 0.50,
            y: -30
        }, {
            x: 0.50,
            y: -35
        }, {
            x: 0.62,
            y: -40
        }, {
            x: 0.86,
            y: -45
        }, {
            x: 0.92,
            y: -50
        }, {
            x: 0.92,
            y: -55
        }, {
            x: 0.92,
            y: -60
        }, {
            x: 0.79,
            y: -65
        }, {
            x: 0.56,
            y: -70
        }, {
            x: 0.50,
            y: -75
        }, {
            x: 0.50,
            y: -80
        }, {
            x: 0.50,
            y: -85
        }, {
            x: 0.50,
            y: -90
        }
        ],
        color: '#FFA07A'
      },
      {
        name: 'Estimated',
        data: [
          {
            x: 0.12,
            y: 0
        }, {
            x: 0.08,
            y: -5
        }, {
            x: 0.04,
            y: -10
        }, {
            x: 0.01,
            y: -15
        }, {
            x: 0.02,
            y: -20
        }, {
            x: 0.07,
            y: -25
        }, {
            x: 0.15,
            y: -30
        }, {
            x: 0.33,
            y: -35
        }, {
            x: 0.53,
            y: -40
        }, {
            x: 0.71,
            y: -45
        }, {
            x: 0.84,
            y: -50
        }, {
            x: 0.88,
            y: -55
        }, {
            x: 0.81,
            y: -60
        }, {
            x: 0.64,
            y: -65
        }, {
            x: 0.45,
            y: -70
        }, {
            x: 0.29,
            y: -75
        }, {
            x: 0.19,
            y: -80
        }, {
            x: 0.09,
            y: -85
        }, {
            x: 0.02,
            y: -90
        }
        ],
        color: '#808080'
      },
      {
        name: 'Current Excavation',
        data: [
          { x: 0.9, y: 225 }, { x: -0.9, y: 225 }
        ],
        type: 'scatter',
        color: 'rgba(124,94,66,0.4)'
      }
    ];

    const dynamicSeries = [];
    for (let i = 0; i < data.length; i++) {
      const entry = data[i];
      const timestamp = data[i][0];
      const dateStr = new Date(timestamp).toLocaleString('en-US', {
        hour12: false
      }).slice(0, -6);
        const dynamicData = [];
        for (let j = 1; j < entry.length; j++) {
          const point = entry[j];
          // const X =data[i][j][1];  
          // const Y =data[i][j][2];  
          const X = typeof point[1] == 'number'?point[1] : 0;
          const Y = typeof point[2] == 'string'?point[2] : 0;
// console.log('x');
// console.log(Y);
        dynamicData.push({ x: X, y:Y });
      }

      dynamicSeries.push({
        name: dateStr,
        data: dynamicData,
        color: getRandomColor()
      });

    }

    setSeries([...datasets, ...dynamicSeries]);
  }, []);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const options = {
    chart: {
      
      markers: {
        size: 6, // ?? Point size (visible point)
        colors: ['#FF4560'],
        enabled: true
      },
      height: 500,
      type: 'line',
      zoom: {
        enabled: false,
        type: 'xy',
        autoScaleYaxis: true
      },
      toolbar: {
        tools: {
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true
        }
      }
    },
    xaxis: {
      type: 'numeric',
      min: -1.0,
      max: 1.0,
      // tickAmount: 10,
      title: {
        text: 'Deflection (inches)'
      },
      // labels: {
      //   formatter: val => val.toFixed(1)
      // }
    },
    yaxis: [
      {
        title: {
          text: 'Depth (feet)'
        },
        min: -90,
        max: 0,
        tickAmount: 18,
        labels: {
          formatter: val => val.toFixed(0)
        }
      },
    //   {
    //     opposite: true,
    //     title: {
    //       text: 'Elevation (feet)'
    //     },
    //     min: 193,
    //     max: 303,
    //     tickAmount: 11
    //   }
    ],
    stroke: {
      width: 2,
      curve: 'straight',
      dashArray: [0, 0, 0, 5] // Optional: Dotted line for excavation
    },
    legend: {
      position: 'left'
    },
    tooltip: {
      shared: false,
      intersect: false
    }
  };

 


  return (
    <div>
      <ApexCharts options={options} series={series} type="line"  />
    </div>
  );
};

export default ISGraph;
